import React from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { Container } from "reactstrap"
import OccupancyRate from "./OccupancyRate"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

const OccupancyRateView = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Occupancy Rate| {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Occupancy Rate" breadcrumbItem="Occupancy Rate" />
          <OccupancyRate />
        </Container>
      </div>
    </React.Fragment>
  )
}

OccupancyRateView.propTypes = {
  match: PropTypes.object,
}

export default withRouter(OccupancyRateView)
